class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
    
    
  }

  onSubmitHandler(evt) {
    console.log('Event',evt); //.target[0].data('six-price'));
    window.EVT = {};
    EVT.eventuals = evt;
    evt.preventDefault();
    // EVT.eventuals.target.querySelector('.quantity__input').getAttribute('data-six-price');
    var matching_items = [];
  
    this.qty = this.querySelector('[name="quantity"]') ? this.querySelector('[name="quantity"]').value : evt.target[0].value;
    this.six_price = evt.target.querySelector('.quantity__input') ? evt.target.querySelector('.quantity__input').getAttribute('data-six-price') : evt.target[0].getAttribute('data-six-price');
    this.cartNotification.setActiveElement(document.activeElement);
    this.availableInventory = evt.target.querySelector('.product-form__submit').getAttribute('data-availableinventory');
   
    // alert(this.availableInventory);
    // alert(this.qty);
    
    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');
    var _this = this;
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      cache: false,
      dataType: 'json',
      success: function(cart) {
        var this_cart = cart;
        var line_items = this_cart.items; 
        line_items.map((item, index) => {
          if(item.variant_id == evt.target.querySelector('.product-form__submit').getAttribute('data-variantid')) {
            matching_items.push(item.quantity);
          }
          return matching_items;
        });
      matching_items.reduce(function(a, b) { return a + b; }, 0);
      // alert(matching_items.reduce(function(a, b) { return a + b; }, 0));
      if (_this.qty > (_this.availableInventory - matching_items.reduce(function(a, b) { return a + b; }, 0))) {
        alert('You can add a maximum of ' + (_this.availableInventory - matching_items.reduce(function(a, b) { return a + b; }, 0)) + ' of this product to your cart.');
        submitButton.setAttribute('disabled', true);
        submitButton.classList.add('loading');
      } else {
      const body = JSON.stringify({
        ...JSON.parse(serializeForm(_this.form)),
        quantity: _this.qty,
        properties: { _promo: window.CMWPromo.promoCode, _six_price: _this.six_price },
        sections: _this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });
      
      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        _this.cartNotification.renderContents(parsedState);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
    };
    submitButton.classList.remove('loading');
    submitButton.removeAttribute('disabled');
  }
    }); 
  }
}

customElements.define('product-form', ProductForm);
